/**
 * S2.6: Cegid NOM API Wrapper (Nóminas/Payroll)
 * Endpoints: Auth, Employees, Payroll
 */

import { cegidFetch } from './auth';
import type { CegidEmpleado, CegidNomina, CegidNominaTotales } from './types';

/**
 * Get employees (lite version).
 * GET /api/Employees/getEmpleadosLite
 */
export async function getEmpleados(): Promise<CegidEmpleado[]> {
  const data = await cegidFetch('nom', '/api/Employees/getEmpleadosLite');
  return Array.isArray(data) ? data : [];
}

/**
 * Get payroll list.
 * GET /api/Payroll/getListadoNominas
 */
export async function getNominas(): Promise<CegidNomina[]> {
  const data = await cegidFetch('nom', '/api/Payroll/getListadoNominas');
  return Array.isArray(data) ? data : [];
}

/**
 * Get payroll totals for a specific payroll.
 * GET /api/Payroll/totalNominas/{id}
 */
export async function getNominaTotales(nominaId: string): Promise<CegidNominaTotales> {
  return cegidFetch('nom', `/api/Payroll/totalNominas/${nominaId}`);
}
